import { useNavigate } from "react-router-dom";
import {
  getAllCoins,
  deleteCoin,
  updateCoin,
  createCoin,
} from "../../../api/coin";
import BootstrapTable from "./CommanPage";
import { accepts } from "react-dropzone-uploader";
const Coins = () => {
  const COIN_FIELD = [
    {
      name: "name",
      label: "Coin Name",
      type: "text",
      placeholder: "Enter your coinname",
      isForm: true,
      isTable: true,
      validation: {
        required: "Coinname is required",
        minLength: {
          value: 3,
          message: "Minimum 3 characters",
        },
      },
    },
    {
      name: "symbol",
      label: "Coin Symbol",
      type: "text",
      placeholder: "Enter your coin symbol",
      isForm: true,
      isTable: true,
      validation: {
        required: "Coin symbol is required",
        minLength: {
          value: 3,
          message: "Minimum 3 characters",
        },
      },
    },
    {
      name: "coinType",
      label: "Coin Type",
      type: "select",
      isForm: true,
      isTable: true,
      options: [
        { value: 0, label: "All" },
        { value: 1, label: "Sports Token" },
        { value: 2, label: "E-Sports Token" },
        { value: 3, label: "MEME Token" },
        { value: 4, label: "AI Token" },
        { value: 5, label: "Exchange Based Token" },
        { value: 6, label: "Stable Token" },
        { value: 7, label: "Digital Assets Token" },
      ],
      validation: {
        required: "Coin type is required",
      },
    },
    {
      name: "logo",
      label: "Logo",
      type: "file",
      placeholder: "Upload Your Logo",
      isForm: true,
      isTable: true,
      //   options: [
      //     { value: "admin", label: "Admin" },
      //     { value: "user", label: "User" },
      //   ],
      validation: {
        required: "Coin Logo is required",
      },
      render: (val) => (
        <img
          src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${val}`}
          className="rounded-circle"
          style={{ height: "50px", width: "50px" }}
          alt="coin logo"
        />
      ),
    },
    {
      name: "totalSupply",
      label: "Total Supply",
      type: "text",
      placeholder: "Enter Your Total Supply",
      isForm: true,
      isTable: true,
      validation: {
        required: "Supply is required",
      },
    },
    {
      name: "maxSupply",
      label: "Max Supply",
      type: "text",
      placeholder: "Enter Your MAX Supply",
      isForm: true,
      isTable: true,
      validation: {
        required: "MAX Supply is required",
      },
    },
    {
      name: "circulatingSupply",
      label: "Circulating Supply",
      type: "text",
      placeholder: "Enter Your Circulating Supply",
      isForm: true,
      isTable: true,
      validation: {
        required: "Circulating Supply is required",
      },
    },
    {
      name: "description",
      label: "Description",
      type: "ckeditor",
      isForm: true,
      isTable: false,
      validation: {
        required: "Description is required",
      },
    },

    {
      name: "isActive",
      label: "Active",
      type: "checkbox",
      isForm: true,
      isTable: true,
      render: (val) => (val ? "✅ Active" : "❌ Inactive"),
    },
    {
      name: "createdAt",
      label: "Created At",
      type: "text",
      isForm: false,
      isTable: true,
      render: (val) => new Date(val).toLocaleString(),
    },
    {
      name: "intradayAvgPrice",
      label: "Intraday Average",
      type: "text",
      isForm: false,
      isTable: true,
    },
    {
      name: "updatedAt",
      label: "Updated At",
      type: "text",
      isForm: false,
      isTable: true,
      render: (val) => new Date(val).toLocaleString(),
    },
  ];
  const navigate = useNavigate();

  const getAllCoinsWithIntradayAvg = (page, recordPerPage, searchQuery) =>
    getAllCoins(
      page,
      recordPerPage,
      searchQuery,
      null,
      null,
      null,
      true
    );

  return (
    <BootstrapTable
      fields={COIN_FIELD}
      title={"Coins"}
      getAllRecord={getAllCoinsWithIntradayAvg}
      deleteRecord={deleteCoin}
      updateRecord={updateCoin}
      createRecord={createCoin}
      searchAble={true}
      menuOptions={(row) => [
        {
          title: "Manage Coin Price",
          click: () => {
            navigate(`manage-coin-price/${row.id}`);
          },
        },
      ]}
    />
  );
};

export default Coins;
